export default "__VITE_ASSET__6071fd91__"